var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import SimilarCourseCard from '../SimilarCourseCard';
var SimilarCoursesSliderComponent = function (_a) {
    var data = _a.data, verifyAddToBookmarks = _a.verifyAddToBookmarks, leadId = _a.leadId, betaFlag = _a.betaFlag, handleClickOnCourseName = _a.handleClickOnCourseName, shownOnTop = _a.shownOnTop, onCourseDetailSectionChange = _a.onCourseDetailSectionChange, onSimilarCoursesViewed = _a.onSimilarCoursesViewed;
    var _b = __read(useState([]), 2), inViewSimilarCourse = _b[0], setInViewSimilarCourse = _b[1];
    var _c = __read(useState([]), 2), visitedSimilarCourse = _c[0], setVisitedSimilarCourse = _c[1];
    var _d = __read(useState(true), 2), isScrollEventsPresent = _d[0], setIsScrollEventsPresent = _d[1];
    var Arrow = function (props) {
        var style = props.style, onClick = props.onClick, direction = props.direction;
        return (React.createElement("img", { className: "lfc-absolute lfc-cursor-pointer lfc-z-100", style: __assign(__assign({}, style), { left: direction === 'next' ? '-40px' : '', right: direction === 'next' ? '' : '-40px', top: '40%' }), onClick: function () {
                if (onClick) {
                    onClick();
                }
                handleEvents();
            }, src: direction === 'next'
                ? '/assets/icons/course-finder/prev-arrow.svg'
                : '/assets/icons/course-finder/next-arrow.svg', alt: direction === 'next' ? 'next' : 'previous' }));
    };
    useEffect(function () {
        var activeSimilarCourse = inViewSimilarCourse[(inViewSimilarCourse === null || inViewSimilarCourse === void 0 ? void 0 : inViewSimilarCourse.length) - 1];
        if (!(visitedSimilarCourse === null || visitedSimilarCourse === void 0 ? void 0 : visitedSimilarCourse.includes(activeSimilarCourse))) {
            setVisitedSimilarCourse(__spreadArray(__spreadArray([], __read(visitedSimilarCourse), false), [activeSimilarCourse], false));
        }
        if ((inViewSimilarCourse === null || inViewSimilarCourse === void 0 ? void 0 : inViewSimilarCourse.length) === (data === null || data === void 0 ? void 0 : data.length)) {
            setIsScrollEventsPresent(false);
        }
        if (isScrollEventsPresent && !(visitedSimilarCourse === null || visitedSimilarCourse === void 0 ? void 0 : visitedSimilarCourse.includes(activeSimilarCourse)) && activeSimilarCourse) {
            var visitedCourseIndex = visitedSimilarCourse[(visitedSimilarCourse === null || visitedSimilarCourse === void 0 ? void 0 : visitedSimilarCourse.length) - 1];
            if (onSimilarCoursesViewed) {
                onSimilarCoursesViewed({
                    data: data[visitedCourseIndex],
                    leadId: leadId,
                    betaFlag: betaFlag
                });
            }
        }
    }, [inViewSimilarCourse]);
    var handleEvents = function () {
        onCourseDetailSectionChange({
            eventName: 'click',
            data: data,
            leadId: leadId,
            contentName: 'View more similar courses',
            widgetName: 'Course details page',
            betaFlag: betaFlag
        });
    };
    var settings = {
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: shownOnTop ? 2.2 : 1.5,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: React.createElement(Arrow, { direction: 'previous' }),
        prevArrow: React.createElement(Arrow, { direction: 'next' })
    };
    return (React.createElement(StyledSlider, __assign({}, settings), data === null || data === void 0 ? void 0 : data.map(function (item, index) {
        return (
        // @ts-expect-error: different react version issue
        React.createElement(InView, { key: index, onChange: function (val) {
                var updatedActiveTab;
                if (val) {
                    updatedActiveTab = __spreadArray(__spreadArray([], __read(inViewSimilarCourse), false), [index], false);
                    setInViewSimilarCourse(updatedActiveTab);
                }
            } },
            React.createElement(SimilarCourseCard, { key: index, page: 'course-detail', data: item, verifyAddToBookmarks: verifyAddToBookmarks, leadId: leadId, courseId: (item === null || item === void 0 ? void 0 : item.courseId) || (item === null || item === void 0 ? void 0 : item.cmsId), handleClickOnCourseName: handleClickOnCourseName })));
    })));
};
export default SimilarCoursesSliderComponent;
var StyledSlider = styled(Slider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .slick-dots {\n    position: absolute;\n    bottom: -35px;\n  }\n  .slick-dots > li {\n    background: #bdbdbd !important;\n    width: 8px !important;\n    height: 8px !important;\n    border-radius: 100% !important;\n    &.slick-active {\n      background: #757575 !important;\n    }\n    & > button:before {\n      font-size: 0 !important;\n    }\n    .slick-prev:before,\n    .slick-next:before {\n      color: yellow;\n    }\n  }\n"], ["\n  .slick-dots {\n    position: absolute;\n    bottom: -35px;\n  }\n  .slick-dots > li {\n    background: #bdbdbd !important;\n    width: 8px !important;\n    height: 8px !important;\n    border-radius: 100% !important;\n    &.slick-active {\n      background: #757575 !important;\n    }\n    & > button:before {\n      font-size: 0 !important;\n    }\n    .slick-prev:before,\n    .slick-next:before {\n      color: yellow;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=SimilarCoursesSliderComponent.js.map